
import { apiFuns } from "sw-hic";
let { get, post, put, del, genStandard } = apiFuns;
let api = {
    Dept: {
    ...genStandard("dept", "/api/md"),
     getDept(id) {
      return get('/api/md/dept/' + id, {})
     },
  }
};
export default api;
